// Н0 — ЕДИНСТВЕНОТО определение на правното основание в клиента.
//
// До 11.08.2026 сметката беше преписана на три места тук (страницата на
// ползвателя, списъкът на землището, обобщението по ползвател) и на три на
// сървъра. Докато формулата не се мени, това не се усеща. Но щом се добави ново
// събираемо, всяко пропуснато копие показва РАЗЛИЧНО правно основание на
// различен екран — и това не изглежда като счупено приложение, а като объркани
// числа.
//
// Огледало на `server/services/pravno.py`. ДВАТА ФАЙЛА СЕ ПРОМЕНЯТ ЗАЕДНО.

// null/undefined/"" → 0. Полетата за площи са nullable в базата.
export const val = (v) => (v ? Number(v) : 0);

// У1 (23.08.2026) — коригираните изходни площи, както се ПОКАЗВАТ.
// Корекцията мести площ от годна в необработваема; декларираната не се пипа.
// Суровите стойности в базата остават непроменени — корекцията е отделен ред
// в „други площи" и се редактира само там.
//
// Дотук тази сметка беше преписана на страницата на ползвателя и в справките,
// а в списъка на землището я нямаше изобщо — затова там числата оставаха
// некоригирани, докато „Правно" на същия ред беше вярно.
export const adjustedUnsuitable = (unsuitableLand, correction) =>
    val(unsuitableLand) + val(correction);

// ⚠️ НЕ подавай това на pravno() — там влиза СУРОВАТА годна, защото формулата
// вече вади корекцията през othersTotal. Двойно вадене дава по-малко правно.
export const adjustedSuitable = (suitableLand, correction) =>
    val(suitableLand) - val(correction);

// Приносът на „други площи". Знаците:
//   + бели петна, + пътища, + Други(+)
//   − Други(−), − корекция
// Това е и стойността на колоната `others.total` на сървъра.
export const othersTotal = (whiteSpots, roads, othersVal, correction, othersPlus = 0) =>
    val(whiteSpots) + val(roads) + val(othersPlus)
    - val(othersVal) - val(correction);

// Правно основание = годна + доброволни замени + принос на другите площи.
// Изразено чрез othersTotal, за да е невъзможно двете да се разминат.
export const pravno = ({
    suitableLand, correction, sumDeals, whiteSpots, roads, othersVal, othersPlus,
}) => val(suitableLand) + val(sumDeals)
    + othersTotal(whiteSpots, roads, othersVal, correction, othersPlus);
